(function() {
  'use strict';

  // ===== NAV SCROLL =====
  var nav = document.querySelector('.site-nav');
  // The header is solid on every page, so it only needs its hairline once the
  // page has moved at all. A transparent-over-hero variant was tried and taken
  // back out: it read as a blank bar.
  if (nav) window.addEventListener('scroll', function() { nav.classList.toggle('scrolled', window.scrollY > 10); }, { passive: true });

  // ===== BACK BUTTON =====
  // Was an inline onclick. Moved here so the markup carries no script.
  var backBtn = document.querySelector('[data-nav-back]');
  if (backBtn) {
    backBtn.addEventListener('click', function(e) {
      if (document.referrer.indexOf(window.location.host) !== -1) {
        e.preventDefault();
        history.back();
      }
    });
  }

  // ===== MOBILE NAV DRAWER =====
  var hamburger = document.getElementById('navHamburger');
  var navCenter = document.getElementById('navCenter');
  if (hamburger && navCenter) {
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function drawerIsOpen() { return navCenter.classList.contains('open'); }

    function focusables() {
      return Array.prototype.filter.call(
        navCenter.querySelectorAll(FOCUSABLE),
        function(el) { return el.offsetParent !== null; }
      );
    }

    function openDrawer() {
      hamburger.classList.add('open');
      navCenter.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-open');
      var items = focusables();
      if (items.length) items[0].focus();
    }

    function closeDrawer(returnFocus) {
      hamburger.classList.remove('open');
      navCenter.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
      if (returnFocus) hamburger.focus();
    }

    hamburger.addEventListener('click', function() {
      if (drawerIsOpen()) closeDrawer(false); else openDrawer();
    });

    navCenter.querySelectorAll('.nav-link').forEach(function(l) {
      l.addEventListener('click', function() { closeDrawer(false); });
    });

    document.addEventListener('click', function(e) {
      if (!drawerIsOpen()) return;
      if (!hamburger.contains(e.target) && !navCenter.contains(e.target)) closeDrawer(false);
    });

    // Escape closes and returns focus to the trigger. Tab is trapped inside
    // the drawer while it is open.
    document.addEventListener('keydown', function(e) {
      if (!drawerIsOpen()) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeDrawer(true);
        return;
      }

      if (e.key !== 'Tab') return;

      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || active === hamburger || !navCenter.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last) {
        e.preventDefault();
        hamburger.focus();
      }
    });

    // A resize past the mobile breakpoint must not leave the body locked.
    window.addEventListener('resize', function() {
      if (drawerIsOpen() && window.innerWidth > 640) closeDrawer(false);
    });
  }

  // ===== COOKIE =====
  // Cookie consent is owned by sections/cookie-consent.liquid (Customer Privacy API).

  // ===== COLLECTION SORT =====
  // Progressive enhancement only. The form is a real GET form and submits on
  // its own without this; this just removes the extra click.
  document.querySelectorAll('[data-sort-form]').forEach(function (form) {
    var select = form.querySelector('select[name="sort_by"]');
    if (!select) return;
    select.addEventListener('change', function () { form.submit(); });
  });

  // ===== NOTIFY ME SIGNUP =====
  // The previous version showed the success message from inside .catch(), so a
  // failed signup told the customer they were on the list. It also never
  // checked response.ok. Both are fixed here: success is shown only on a
  // genuine success.
  document.querySelectorAll('[data-notify-form]').forEach(function (form) {
    var input = form.querySelector('[data-notify-input]');
    var label = form.querySelector('[data-notify-label]');
    var errEl = form.querySelector('[data-notify-error]');
    var okEl = form.querySelector('[data-notify-success]');
    var fine = form.querySelector('[data-notify-fine]');
    var submit = form.querySelector('[data-notify-submit]');
    if (!input || !submit) return;

    function mode() { return form.getAttribute('data-mode') || 'email'; }

    function setMode(next) {
      form.setAttribute('data-mode', next);
      var isEmail = next === 'email';
      input.type = isEmail ? 'email' : 'tel';
      input.inputMode = isEmail ? 'email' : 'tel';
      input.autocomplete = isEmail ? 'email' : 'tel';
      input.value = '';
      if (label) {
        label.childNodes[0].nodeValue = isEmail ? 'Email address' : 'Phone number';
      }
      if (fine) fine.hidden = isEmail;
      hide(errEl); hide(okEl);
    }

    function show(el, msg) { if (!el) return; if (msg) el.textContent = msg; el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    form.querySelectorAll('[data-notify-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-notify-mode]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        setMode(btn.getAttribute('data-notify-mode'));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hide(errEl); hide(okEl);

      var raw = input.value.trim();
      var body;

      if (mode() === 'email') {
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(raw)) {
          return show(errEl, 'Enter a valid email address.');
        }
        body = 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(raw) +
               '&contact%5Btags%5D=coming-soon,email-signup';
      } else {
        var phone = raw.replace(/[^\d+]/g, '');
        if (phone.length < 10) {
          return show(errEl, 'Enter a valid phone number.');
        }
        body = 'form_type=customer&utf8=%E2%9C%93&contact%5Bphone%5D=' + encodeURIComponent(phone) +
               '&contact%5Btags%5D=coming-soon,sms-signup';
      }

      submit.disabled = true;
      if (!window.fetch) { form.submit(); return; }

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Sorry, that could not be saved. Please try again.');
          show(okEl);
          input.value = '';
        })
        .catch(function (err) {
          show(errEl, (err && err.message) || 'Sorry, that could not be saved. Please try again.');
        })
        .then(function () { submit.disabled = false; });
    });
  });

  // ===== PRODUCT MEDIA SLIDESHOW =====
  // Arrow keys are scoped to the slideshow. They used to be bound on document,
  // which hijacked ArrowLeft and ArrowRight across the entire page, including
  // inside form fields, whenever a slideshow existed.
  var track = document.getElementById('carouselTrack');
  if (track) {
    var slides = track.querySelectorAll('.carousel-slide');
    var dots = Array.prototype.slice.call(document.querySelectorAll('.carousel-dot'));
    var region = track.closest('.pd-carousel-outer') || track.parentNode;
    var current = 0;
    var total = slides.length;

    function goTo(i) {
      if (total === 0) return;
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      current = i;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, idx) {
        var active = idx === current;
        d.classList.toggle('active', active);
        d.setAttribute('aria-current', active ? 'true' : 'false');
      });
      slides.forEach(function (sl, idx) {
        sl.setAttribute('aria-hidden', idx === current ? 'false' : 'true');
      });
    }

    var prev = document.getElementById('carouselPrev');
    var next = document.getElementById('carouselNext');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.getAttribute('data-index'), 10));
      });
    });

    var sx = 0, drag = false;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; drag = true; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!drag) return;
      var d = sx - e.changedTouches[0].clientX;
      if (Math.abs(d) > 50) { d > 0 ? goTo(current + 1) : goTo(current - 1); }
      drag = false;
    });

    // Scoped to the slideshow, and only while focus is inside it.
    if (region) {
      region.addEventListener('keydown', function (e) {
        if (!region.contains(document.activeElement)) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
    }

    goTo(0);
  }

  // ===== PRODUCT CAROUSEL =====
  // A separate component from the slideshow above. The base markup is a native
  // horizontally scrolling list, so it works with no JavaScript at all. Arrows
  // and state below are progressive enhancement.
  document.querySelectorAll('[data-product-carousel]').forEach(function (root) {
    var viewport = root.querySelector('[data-carousel-viewport]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!viewport) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = viewport.querySelector('.product-card-slide');
      if (!card) return viewport.clientWidth;
      var gap = parseFloat(getComputedStyle(viewport).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCards(dir) {
      viewport.scrollBy({
        left: dir * step(),
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    function syncArrows() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      // Sub-pixel scroll positions and snap offsets mean scrollLeft rarely
      // lands exactly on 0, so allow a small tolerance.
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= max;
      var scrollable = viewport.scrollWidth > viewport.clientWidth + 1;
      [prevBtn, nextBtn].forEach(function (b) {
        if (b) b.hidden = !scrollable;
      });
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

    // Scoped to this carousel, and only while focus is inside it.
    root.addEventListener('keydown', function (e) {
      if (!root.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByCards(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByCards(1); }
    });

    viewport.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();
  });

  // ===== PRODUCT: VARIANT SELECTION AND ADD TO CART =====
  // Selection and submission are separate actions. Choosing the last option
  // used to fire ajaxAdd() immediately, so changing your mind about a size
  // added the product to the cart.
  var form = document.getElementById('productForm');
  var addBtn = document.getElementById('addToCartBtn');

  if (form && addBtn) {
    var variantSelect = document.getElementById('productVariants');
    var variantDataEl = document.getElementById('productVariantData');
    var confirmation = document.getElementById('cartConfirmation');
    var errorEl = document.getElementById('cartError');
    var priceEl = document.getElementById('productPrice');
    var label = addBtn.querySelector('.pd-add-label');
    // The options panel sits outside the form (the size guide renders between
    // them), so scoping the lookup to the form finds nothing.
    var optionsRoot = document.getElementById('optionsPanel') || form;
    var optionInputs = Array.prototype.slice.call(optionsRoot.querySelectorAll('.option-input'));

    var variants = [];
    try { if (variantDataEl) variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }

    function selectedOptions() {
      var out = [];
      optionInputs.forEach(function (input) {
        if (input.checked) out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return out;
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options.length !== opts.length) continue;
        var same = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { same = false; break; }
        }
        if (same) return v;
      }
      return null;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function setBusy(busy) {
      addBtn.disabled = busy;
      addBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (label) label.textContent = busy ? 'Adding...' : 'Add to cart';
    }

    // Selection only updates state. It never submits.
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        clearError();
        var match = matchVariant(selectedOptions());
        if (!match) {
          if (label) label.textContent = 'Unavailable';
          addBtn.disabled = true;
          return;
        }
        if (variantSelect) variantSelect.value = String(match.id);
        if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        addBtn.disabled = !match.available;
        if (label) label.textContent = match.available ? 'Add to cart' : 'Sold out';
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // let the browser post the form natively
      e.preventDefault();
      clearError();

      var variantId = variantSelect ? variantSelect.value : null;
      if (!variantId) { form.submit(); return; }

      setBusy(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (response) {
          // A 422 (sold out, unavailable variant) still parses as JSON. The old
          // code never checked, so a failed add showed the success message and
          // the customer believed the item was in their cart.
          return response.json()
            .catch(function () { return {}; })
            .then(function (body) {
              if (!response.ok) {
                var msg = body && (body.description || body.message);
                throw new Error(msg || 'Sorry, that could not be added to your cart.');
              }
              return body;
            });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              if (!cart) return;
              var counts = document.querySelectorAll('.cart-count');
              if (counts.length) {
                counts.forEach(function (el) { el.textContent = cart.item_count; });
              } else {
                var link = document.querySelector('.nav-cart');
                if (link) {
                  var span = document.createElement('span');
                  span.className = 'cart-count';
                  span.textContent = cart.item_count;
                  link.insertBefore(span, link.firstChild);
                }
              }
            });
        })
        .then(function () {
          if (confirmation) {
            confirmation.hidden = false;
            setTimeout(function () { confirmation.hidden = true; }, 4000);
          }
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Sorry, that could not be added to your cart.');
        })
        .then(function () {
          setBusy(false);
        });
    });
  }


  /* ===== ANNOUNCEMENT BAR =====
     Rotation is progressive enhancement: every message is already in the DOM
     and the first one is visible, so with this script absent the bar still
     shows an announcement. Pausing is a real requirement (WCAG 2.2.2), so the
     timer also stops on hover and on keyboard focus inside the bar, and it
     never starts at all when the visitor has asked for reduced motion. */
  (function () {
    var bars = document.querySelectorAll('[data-annbar-rotate]');
    if (!bars.length) return;

    var reduced = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(bars, function (bar) {
      var items = bar.querySelectorAll('[data-annbar-item]');
      if (items.length < 2) return;

      var pause = bar.querySelector('[data-annbar-pause]');
      var wait = parseInt(bar.getAttribute('data-annbar-interval'), 10) || 5000;
      var at = 0;
      var timer = null;
      // Held by the visitor: the button. Held by circumstance: hover, focus.
      // Both must be clear before the timer runs again.
      var stopped = reduced;
      var hovered = false;

      function show(next) {
        items[at].classList.remove('is-active');
        items[at].setAttribute('aria-hidden', 'true');
        at = next;
        items[at].classList.add('is-active');
        items[at].removeAttribute('aria-hidden');
      }

      function tick() { show((at + 1) % items.length); }

      function run() {
        clear();
        if (stopped || hovered) return;
        timer = setInterval(tick, wait);
      }

      function clear() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (pause) {
        // Reduced motion means it is already paused, so the control should say
        // so rather than claim it is playing.
        if (reduced) {
          pause.setAttribute('aria-pressed', 'true');
          pause.setAttribute('aria-label', 'Play announcements');
        }
        pause.addEventListener('click', function () {
          stopped = !stopped;
          pause.setAttribute('aria-pressed', stopped ? 'true' : 'false');
          pause.setAttribute('aria-label', stopped ? 'Play announcements' : 'Pause announcements');
          run();
        });
      }

      bar.addEventListener('mouseenter', function () { hovered = true; clear(); });
      bar.addEventListener('mouseleave', function () { hovered = false; run(); });
      bar.addEventListener('focusin', function () { hovered = true; clear(); });
      bar.addEventListener('focusout', function () {
        if (!bar.contains(document.activeElement)) { hovered = false; run(); }
      });

      // A background tab should not burn through the messages unseen.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clear(); } else { run(); }
      });

      run();
    });
  })();

})();
